export const pagesAttendanceCoreEn = {
  archiveScreen: {
    description: 'Archived operation packages will appear here.',
    title: 'Archive'
  },
  configScreen: {
    description: 'Attendance specification settings will appear here.',
    title: 'Config'
  },
  dashboard: {
    comparedToLastMonth: 'vs last month',
    gantt: {
      barLabels: {
        adjustmentProgress: 'Adjustment pending',
        approvalRatio: 'Line approvals: 18/24',
        clockInCoverage: 'Punches captured: 698/700',
        confirm: 'Confirm',
        confirmationProgress: 'Confirmation pending',
        handoffPending: 'Payroll handoff (scheduled)',
        lockedForPayroll: 'Period lock (scheduled)',
        missingPunchQueue: 'Missing punches: 12 open',
        overtimeAllocation: 'Overtime vs 36 agreement: 92%',
        solicitationProgress: 'Requests sent: 5/5 stores',
        staffingPlanProgress: 'Staffing plan: 6/6 stores',
        submissionProgress: 'Preferences in: 3/5 stores'
      },
      calendar: {
        moreCount: '+{{count}} more',
        nextPeriod: 'Next',
        noEventsThisWeek: 'No items in this window.',
        previousPeriod: 'Previous',
        status: {
          done: 'Done',
          inProgress: 'In progress',
          todo: 'Not started'
        },
        taskAria: '{{status}} — {{label}} — {{date}}',
        today: 'Today'
      },
      dataView: {
        assignees: {
          '0': 'Payroll / HR operations',
          '1': 'Attendance administration',
          '2': 'Corporate accounting',
          '3': 'IT / integrations'
        },
        attention: {
          no: '—',
          yes: 'Yes'
        },
        closureStatus: {
          draft: 'Draft',
          inReview: 'In review',
          locked: 'Locked'
        },
        emptyFiltered: 'No rows match the current filters.',
        exportToastTitle: 'Export is not available in preview.',
        fixtures: {
          departments: {
            d1: 'Sales Operations',
            d2: 'Store Operations',
            d3: 'Corporate HQ'
          },
          employees: {
            e1: 'Hanako Aoyama',
            e2: 'Taro Sato',
            e3: 'Yuki Nakamura',
            e4: 'Ken Ito',
            e5: 'Mei Fujita'
          },
          workplaces: {
            w1: 'Tokyo HQ',
            w2: 'Osaka Store',
            w3: 'Yokohama DC'
          }
        },
        readiness: {
          blocked: 'Blocked',
          pending: 'Pending checks',
          ready: 'Ready to close'
        },
        rowKinds: {
          event: 'Event',
          step: 'Step'
        },
        scopes: {
          byPlace: 'places',
          daily: 'Daily attendance',
          monthly: 'Employee'
        },
        searchPlaceholder: 'Search events, steps, or assignees',
        searchPlaceholderAttendance: 'Search by employee, date, workplace, or code',
        tabs: {
          all: 'All',
          attention: 'Needs attention',
          done: 'Done',
          inProgress: 'In progress'
        },
        workStatus: {
          leave: 'Paid leave',
          missingOut: 'Missing clock-out',
          normal: 'Normal'
        }
      },
      eventTitles: {
        flexWorkPolicyReview: 'Flex settlement period revision – starting June',
        monthlyClosingOctober: 'Monthly attendance close – May',
        shiftOrganizationJun: 'Shift planning – June',
        shiftOrganizationJunSapporo: 'Shift planning – June (Sapporo)',
        shiftOrganizationJunTsukiji: 'Shift planning – June (Tsukiji)',
        shiftOrganizationMay: 'Shift planning – May',
        shiftOrganizationMaySapporo: 'Shift planning – May (Sapporo)',
        shiftOrganizationMayTsukiji: 'Shift planning – May (Tsukiji)'
      },
      loadError: 'Could not load the dashboard.',
      steps: {
        agreement36Check: '36-agreement & overtime check',
        collectTimeClockData: 'Collect time clock data',
        exportLockedTimesheet: 'Export locked timesheet',
        lockMonthlyAttendance: 'Lock monthly attendance',
        managerLineApprovals: 'Attendance manager approval',
        resolveMissingPunches: 'Month-end punch close request',
        shiftAdjustment: 'Shift adjustment',
        shiftConfirmation: 'Shift confirmation',
        shiftRequestSolicitation: 'Request shift preferences',
        shiftRequestSubmission: 'Collect shift preferences',
        staffingPlan: 'Staffing plan'
      },
      taskColumn: {
        filterAria: 'Filter task list',
        title: 'Attendance events & steps'
      },
      toolbar: {
        assignee: 'Assignee',
        assigneeSelf: 'Me',
        calendarPlacementByEvent: 'By event',
        calendarPlacementDeadline: 'By deadline',
        calendarPlacementLabel: 'Display',
        granularity: {
          month: 'Monthly',
          quarter: 'Quarterly',
          week: 'Weekly'
        },
        settingsAria: 'Gantt display settings',
        viewCalendar: 'Calendar',
        viewData: 'Data',
        viewGantt: 'Gantt'
      }
    },
    noMetrics: 'No metrics data available',
    title: 'Dashboard'
  },
  instance: {
    assignee: 'Assignee',
    attendanceCore: 'Attendance core',
    instanceStatus: {
      archived: 'Archived',
      completed: 'Completed',
      inProgress: 'In Progress'
    },
    notStarted: 'This operation task is not started yet and cannot be edited. It starts when the dependent prior operation task is completed.',
    progress: {
      title: 'Task Progress'
    },
    requestedFor: 'Requested for',
    tabs: {
      data: 'Data',
      detail: 'Detail',
      operationActivity: 'Operation Activity'
    },
    task: {
      approveSuccess: 'Task approved successfully',
      editSuccess: 'Task updated successfully'
    }
  },
  operationPackages: {
    assignTaskToPerson: {
      anchorDate: 'Anchor date',
      assignSuccess: 'Operation package started successfully',
      assignSuccessMessage: '{{count}} people assigned',
      selectPackage: 'Select operation package',
      selectPackageDescription: 'Select the operation package you want to start',
      selectPackagePattern: 'Select operation package pattern',
      selectPackagePatternDescription: 'Select the operation package pattern you want to start',
      selectPerson: 'Select target',
      selectPersonDescription: 'Select the target to assign',
      selectPersonPlaceholder: 'Select target',
      selectedOperationPackage: 'Selected operation package',
      selectedOperationPattern: 'Selected operation package pattern',
      selectedPerson: 'Selected target',
      startOperationTask: 'Start operation package',
      startOperationTaskDescription: 'Start the operation task by selecting the operation package and pattern, and then assigning the target.',
      validationErrors: {
        noPersonSelected: 'Please select at least one person to assign',
        pastDateWithNewPerson: 'Choose the future dates when adding new people'
      }
    },
    attendanceCore: 'Attendance core',
    categories: {
      bonus_processing: 'Bonus Processing',
      mid_year_adjustment: 'Mid-Year Adjustment',
      monthly_close: 'Monthly Close',
      offboarding: 'Offboarding',
      onboarding: 'Onboarding',
      year_end: 'Year-End'
    },
    displayDataAggregate: 'View: Data summary',
    filterByPerson: 'Filter by person',
    leaveRequestPatternTabs: {
      all: 'All',
      condolenceLeave: 'Condolence / ceremonial leave',
      menstrualLeave: 'Menstrual leave',
      nursingCareLeave: 'Nursing / care leave',
      paidLeaveAdvance: 'Paid leave (advance)',
      paidLeaveAfter: 'Paid leave (after)',
      summerLeave: 'Summer leave'
    },
    mockPatternMutation: {
      description: 'Pattern changes are not available in the demo database.',
      title: 'Demo mode'
    },
    noPackages: 'No operation packages available',
    patternEmptyState: {
      description: 'No operation package pattern found. Please register from the Add pattern button above.',
      title: 'No operation package pattern'
    },
    /** Keys referenced by Dexie `AttendanceOpPackagePattern.nameKey`. */
    patternTabKeys: {
      default: 'All',
      leave_all: 'All',
      leave_condolence: 'Condolence / ceremonial leave',
      leave_menstrual: 'Menstrual leave',
      leave_nursingCare: 'Nursing / care leave',
      leave_paidAdvance: 'Paid leave (advance)',
      leave_paidAfter: 'Paid leave (after)',
      leave_summer: 'Summer leave'
    },
    shiftCoverage: {
      position: 'Position',
      requester: 'Requester',
      supportStore: 'Support store'
    },
    sideTab: {
      underDevelopment: 'This operation package is currently under development.'
    },
    sidebar: {
      absenceRequest: 'Absence request',
      article36Report: 'Article 36 agreement report',
      attendanceClosing: 'Attendance closing',
      attendanceGuidanceInterview: 'Attendance guidance interview',
      doctorInterviewGuidance: 'Doctor interview guidance',
      holidayWorkRequest: 'Holiday work request',
      leaveRequest: 'Leave request',
      overtimeCorrectionNotice: 'Overtime correction notice',
      overtimeRequest: 'Overtime request',
      paidLeaveConsumptionCall: 'Paid leave consumption reminder',
      punchRequest: 'Punch correction request',
      shiftCoverageRequest: 'Shift Coverage Request',
      shiftOrganization: 'Shift planning',
      timesheetShiftRequest: 'Timesheet & shift request'
    },
    startNew: 'Start new',
    status: {
      approval: 'Approval',
      approvalRequired: 'Approval Required',
      attachment: 'Attachment',
      completed: 'Completed',
      notRequired: 'Not Required',
      todo: 'Not Started'
    },
    steps: '{{count}} steps',
    tabs: {
      archive: 'Archive',
      config: 'Config',
      operationPackages: 'Operation packages',
      settings: 'Settings'
    },
    taskEmptyState: {
      description: 'Initiate from the start new button above.',
      title: 'No Operation task'
    },
    title: 'Operation Packages',
    types: {
      attendance: 'Attendance',
      payroll: 'Payroll',
      payroll_attendance: 'Payroll & Attendance'
    }
  },
  pageTitle: 'Attendance core',
  shiftRostering: {
    dataView: {
      columns: {
        employmentType: 'Employment',
        laborCost: 'Projected labor cost',
        member: 'Member',
        orgUnit: 'Org unit',
        plannedHours: 'Working hours',
        scheduledDays: 'Scheduled days',
        staff: 'Headcount',
        store: 'Store'
      },
      employmentType: {
        full_time: 'Full-time',
        part_time: 'Part-time'
      },
      position: {
        cashier: 'Cashier',
        cosmetics: 'Cosmetics',
        pharmacist: 'Pharmacist',
        registeredSeller: 'Registered seller',
        stocker: 'Stocker'
      },
      units: {
        days: '{{value}} d',
        hours: '{{value}} h',
        staff: '{{value}} ppl',
        stores: '{{value}} stores'
      },
      viewMode: {
        label: 'View',
        member: 'Members',
        orgUnit: 'Org units',
        place: 'Stores'
      }
    },
    instanceFilter: 'Shift planning',
    ledgers: {
      comingSoon: 'Coming soon',
      open: 'Open ledger',
      shiftPlan: 'Shift plan',
      shiftRequest: 'Shift preferences',
      title: 'Record ledgers generated by this package',
      workSchedule: 'Work schedule (shift)'
    },
    mode: {
      events: 'Operation views',
      flow: 'Step flow'
    },
    pageTitle: 'Shift planning',
    viewStep: 'Step'
  },
  tabs: {
    archive: 'Archive',
    config: 'Config',
    dashboard: 'Attendance closing',
    operationPackages: 'Operation Packages',
    shiftRostering: 'Shift planning'
  }
};